import { Component, OnInit } from '@angular/core';
import { Confrontation } from '../../../shared';

import { IssuesService } from "../services/issues.service";

import { IssueConstants } from "../issues.const";

@Component({
  selector: 'app-all-issue',
  templateUrl: './all-issue.component.html'
})
export class AllIssueComponent implements OnInit {

  config = Confrontation;
  issues: any;
  tempIssues: any;
  perPage:number = 1;
  pageId:number = 1;
  issueCount:number = 1;
  pageCount:number = 1;

  inputFilter: string;

  issueConstants:any = IssueConstants;

  constructor(
    private issuesService: IssuesService,
  ) { }

  ngOnInit() {
    // get the latasr current page
    let currentPage = this.issuesService.getCurrentPage();
    this.pageId = currentPage
    this.getAllIssue(this.pageId);
  }

  getAllIssue(pageId){
    this.issuesService.getIssues(pageId).subscribe(
      res=>{
        if(res.data && res.data.data){
        this.issues = res.data.data;
        this.tempIssues = res.data.data;
        this.inputFilter = null;

        this.perPage = res.data.per_page
        this.pageId = res.data.current_page
        this.issueCount = res.data.total
        this.pageCount = res.data.last_page
      }
      this.scrollThePage();
      }
    );
  }

  issueFilter(v: any){
    if(!v){
      this.issues = Object.assign([], this.tempIssues);
    }else{
      let val = v.toLowerCase();
      this.issues = Object.assign([], this.tempIssues);
      this.issues = this.issues.filter(ele => {
        let isProjectName = ele.project ? ele.project.name ? ele.project.name.toLowerCase().indexOf(val) > -1: false : false;
        let isIssueStatus = ele.status_obj ? ele.status_obj.title ? ele.status_obj.title.toLowerCase().indexOf(val) > -1 : false : false;
        return isProjectName || isIssueStatus;
      });
    }
  }

  pageChanged(event){
    this.getAllIssue(event);
    // set the latast page id
    this.issuesService.setCurrentPage(event)
  }

   /**
   * kauhslya
   * 2017-08-16
   * scroll The Page
   * @param event
  //  */
  scrollThePage(){
    window.scrollTo(0,0);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/issues/components/all-issue.component.ts